import { render, staticRenderFns } from "./TypographyBlockquotes.vue?vue&type=template&id=ad0cf154&"
import script from "./TypographyBlockquotes.vue?vue&type=script&lang=js&"
export * from "./TypographyBlockquotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports